// extracted by mini-css-extract-plugin
export var quantityInput = "_mq-0";